import { EDRResponse, EDRResponses } from "@theprelude/sdk";
import { EyeIcon } from "../icons/eye-icon";
import { ShieldFlash } from "../icons/shield-flash-icon";
import { SignalIcon } from "../icons/signal-icon";

const ResponseIcons = {
  [EDRResponses.OBSERVE]: EyeIcon,
  [EDRResponses.DETECT]: SignalIcon,
  [EDRResponses.PREVENT]: ShieldFlash,
  [EDRResponses.INVALID]: null,
} as const;

type PartnerIconProps = React.SVGProps<SVGSVGElement> & {
  expectedResponse: EDRResponse | null;
};

export const ResponseIcon: React.FC<PartnerIconProps> = ({
  expectedResponse,
  ...props
}) => {
  if (!expectedResponse) {
    return null;
  }
  const Icon = ResponseIcons[expectedResponse];

  if (!Icon) {
    return null;
  }

  return <Icon {...props} />;
};
